import { MembershipsDirectMessagesApiClient } from '@fourthwall/services/dist/MembershipsDirectMessagesApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'

export const useDirectMessagesWidgetQuery = createQueryHook(
  MembershipsDirectMessagesApiClient.getDirectMessagesWidget,
  {
    queryKey: ['directMessagesWidget'],
  },
)
